/**
 * A curried function that takes in a string of a string union (i.e. 'foo' | 'bar' | 'baz')
 * and returns a function that takes an object with the keys being all the possible values
 * of the union and a function to run if the inputted string is matched on
 *
 * @template {string} S - The input generic which has to be of type string
 * @template Out - The Output generic type
 *
 * @param {S} s - The input string which is part of a string union type
 * @returns {(matchObj: {[K in S]: () => Out}) => Out} s - The return function
 *  which takes in a matcher obj and then run the function passed in the matcher
 *  object that is the value of the key for the input string
 *
 * @example
 * ```js
 * const [phase, setPhase] = useState('foo');
 * const matchPhase = matchString(phase);
 * matchPhase({
    foo: () => <FooComponent />,
    bar: () => <BarComponent closeModal={close} />,
    baz: () => <BazComponent closeModal={close} />,
   })
 * ```
 */

export const matchString =
  <S extends string>(matchKey: S) =>
  <Out>(matchObj: Record<S, () => Out>): Out =>
    matchObj[matchKey]();
